import React, { useMemo } from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { useQueueChatPauseContext } from '../../../../../../hooks/useQueuePauseChatServicePanel';
import { useQueueContentChatContext } from '../../../../../../hooks/useQueueContentChat';

export const FilterQueueOptions = ({
  open,
  openDropDown,
  handlerFilter,
  children
}) => {
  const { filters } = useQueueContentChatContext();

  const queuesFiltered = filters['FILA'];
  const { queuesChatLoggedValues, queues: queuesMap } =
    useQueueChatPauseContext();

  const queuesToList = useMemo(() => {
    return queuesChatLoggedValues.map((queueId) => {
      const queue = queuesMap.get(queueId);
      if (queue) return queue;
    });
  }, [queuesMap]);

  return (
    <Dropdown
      direction="right"
      style={{
        display: 'flex',
        border: 'none',
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100%'
      }}
      onMouseEnter={() => openDropDown(true)}
      onMouseLeave={() => {
        openDropDown(false);
      }}
      isOpen={open}
      toggle={() => openDropDown(!open)}
    >
      {children}
      <DropdownMenu
        style={{
          marginLeft: '-10px'
        }}
        className="DropdownMenu"
      >
        <DropdownItem
          toggle={false}
          onClick={(e) => {
            handlerFilter('ALL', 'FILA');
            document.getElementById(`dropdownItemQueueALL`).checked = true;
            e.stopPropagation();
          }}
          onMouseEnter={() => openDropDown(true)}
        >
          <input
            id={`dropdownItemQueueALL`}
            type="checkbox"
            checked={!queuesFiltered?.length}
            onChange={() => handlerFilter('ALL', 'FILA')}
            onClick={(e) => {
              handlerFilter('ALL', 'FILA');
              e.stopPropagation();
            }}
            style={{ marginRight: '5px' }}
          />
          Todas
        </DropdownItem>
        <DropdownItem divider />
        {queuesToList?.map((queue, index) => {
          if (!queue) return null;
          return (
            <DropdownItem
              key={`dropdownitem+${queue.id}+${index}`}
              value={queue.name}
              toggle={false}
              onClick={(e) => {
                document.getElementById(
                  `dropdownitem+${queue.id}+${index}`
                ).checked = !document.getElementById(
                  `dropdownitem+${queue.id}+${index}`
                ).checked;
                handlerFilter(queue.name, 'FILA');
                e.stopPropagation();
              }}
            >
              <input
                id={`dropdownitem+${queue.id}+${index}`}
                type="checkbox"
                value={queue.name}
                checked={queuesFiltered?.includes(queue.name)}
                onClick={(e) => {
                  handlerFilter(queue.name, 'FILA');
                  e.stopPropagation();
                }}
                style={{ marginRight: '5px' }}
              />
              {queue.name}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};
